import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useState } from 'react';
import clsx from 'clsx';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
/**
 * Displays the site header.
 */

export default function Header(_ref) {
  var className = _ref.className,
      sticky = _ref.sticky,
      shrinkOffset = _ref.shrinkOffset,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "sticky", "shrinkOffset", "children"]); // state indicating whether header is condensed


  var _useState = useState(false),
      shrink = _useState[0],
      setShrink = _useState[1];

  useScrollPosition(function (_ref2) {
    var prevPos = _ref2.prevPos,
        currPos = _ref2.currPos; // ignore scroll position if no scroll shrink

    if (!shrinkOffset && shrinkOffset !== 0) return; // check if conditions are met and shrink header

    currPos.y > shrinkOffset && shrink && setShrink(false);
    currPos.y < shrinkOffset && !shrink && setShrink(true);
  });
  return /*#__PURE__*/React.createElement("header", _extends({
    className: clsx('header', className, {
      'header--shrink': shrink,
      'header--sticky': sticky
    })
  }, props), children);
}
Header.defaultProps = {
  className: null,
  sticky: false,
  shrinkOffset: null
};